import { Logger, Segment } from '@doordash/lib-tracking'
import { isLocal } from '../utilities/environment'

/**
 * Creates a logger target to output the data from the events to the console
 */
function log() {
  return [Logger.client()]
}

function api() {
  return {
    segmentApi: Segment.client(),
  }
}

/**
 * Creates the instrumentation APIs depending on the provided
 * environment settings.
 *
 * @param {string} environment enum declaring where the application is currently
 * running (prod, local, etc.)
 */
export const createApi = environment => (isLocal(environment) ? log() : api())
